import * as React from 'react'

const pulse = 'animate-pulse bg-gray-200'

const AdminSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar placeholder */}
      <div className="fixed inset-y-0 left-0 z-40 w-64 bg-white border-r border-gray-200 hidden lg:block">
        <div className="h-16 border-b border-gray-200 flex items-center px-6">
          <div className={`${pulse} h-5 w-32 rounded`}></div>
        </div>
        <div className="p-3 space-y-2">
          {Array.from({ length: 11 }).map((_, idx) => (
            <div key={idx} className={`h-9 rounded ${pulse}`}></div>
          ))}
        </div>
      </div>

      {/* Main */}
      <div className="lg:pl-64">
        {/* Top bar */}
        <div className="bg-white border-b border-gray-200">
          <div className="h-16 px-4 sm:px-6 flex items-center justify-between">
            <div className="lg:hidden h-8 w-8 rounded-md border border-gray-200 flex items-center justify-center">
              <div className={`${pulse} h-4 w-4 rounded`}></div>
            </div>
            <div className="flex-1" />
            <div className="flex items-center space-x-3">
              <div className={`${pulse} h-5 w-40 rounded`}></div>
              <div className={`${pulse} h-9 w-24 rounded-md`}></div>
            </div>
          </div>
        </div>

        {/* Content skeleton */}
        <div className="p-6 space-y-8">
          {/* Header */}
          <div className="flex items-center justify-between">
            <div>
              <div className={`${pulse} h-8 w-64 rounded mb-2`}></div>
              <div className={`${pulse} h-4 w-80 rounded`}></div>
            </div>
            <div className="flex items-center space-x-3">
              <div className={`${pulse} h-10 w-28 rounded`}></div>
              <div className={`${pulse} h-10 w-40 rounded`}></div>
            </div>
          </div>

          {/* Stats cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {Array.from({ length: 4 }).map((_, idx) => (
              <div key={idx} className="bg-white rounded-lg border border-gray-200 p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <div className={`${pulse} h-4 w-32 rounded mb-2`}></div>
                    <div className={`${pulse} h-6 w-20 rounded`}></div>
                  </div>
                  <div className={`${pulse} h-10 w-10 rounded-lg`}></div>
                </div>
              </div>
            ))}
          </div>

          {/* Table */}
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="border-b border-gray-100">
              <div className="grid grid-cols-6 gap-4 px-6 py-3">
                {Array.from({ length: 6 }).map((_, idx) => (
                  <div key={idx} className={`${pulse} h-4 rounded`}></div>
                ))}
              </div>
            </div>
            <div>
              {Array.from({ length: 6 }).map((_, row) => (
                <div key={row} className="grid grid-cols-6 gap-4 px-6 py-4 border-b border-gray-100">
                  {Array.from({ length: 6 }).map((__, col) => (
                    <div key={col} className={`${pulse} h-4 rounded`}></div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminSkeleton



